export default __webpack_public_path__ + "049c110b.jpg";